/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */

export type SsoLinkUserTypeFilter = typeof SsoLinkUserTypeFilter[keyof typeof SsoLinkUserTypeFilter];


export const SsoLinkUserTypeFilter = {
  User: 'User',
  WebUser: 'WebUser',
  WindowsUsers: 'WindowsUsers',
} as const;
